/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPoliciesListForMcpServer } from "../funcs/riskPoliciesListForMcpServer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRiskPoliciesResult } from "../models/components/listriskpoliciesresult.js";
import {
  ListRiskPoliciesForMcpServerRequest,
  ListRiskPoliciesForMcpServerSecurity,
} from "../models/operations/listriskpoliciesformcpserver.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListPoliciesForMcpServerQueryData = ListRiskPoliciesResult;

export function prefetchRiskListPoliciesForMcpServer(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListRiskPoliciesForMcpServerRequest,
  security?: ListRiskPoliciesForMcpServerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListPoliciesForMcpServerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListPoliciesForMcpServerQuery(
  client$: GramCore,
  request: ListRiskPoliciesForMcpServerRequest,
  security?: ListRiskPoliciesForMcpServerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListPoliciesForMcpServerQueryData>;
} {
  return {
    queryKey: queryKeyRiskListPoliciesForMcpServer({
      mcpServerId: request.mcpServerId,
      toolName: request.toolName,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function riskListPoliciesForMcpServerQueryFn(
      ctx,
    ): Promise<RiskListPoliciesForMcpServerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskPoliciesListForMcpServer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListPoliciesForMcpServer(
  parameters: {
    mcpServerId: string;
    toolName?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "policies", "listForMcpServer", parameters];
}
